import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/clubs.literals';

@Injectable({
  providedIn: 'root',
})
export class ClubsLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  clubName$ = this.storeSelect(selectors.getClubName);
  clubCode$ = this.storeSelect(selectors.getClubCode);
  clubStartDate$ = this.storeSelect(selectors.getClubStartDate);
  clubEndDate$ = this.storeSelect(selectors.getClubEndDate);
  name$ = this.storeSelect(selectors.getName);
  code$ = this.storeSelect(selectors.getCode);
  startDate$ = this.storeSelect(selectors.getStartDate);
  endDate$ = this.storeSelect(selectors.getEndDate);
  showInactiveClubs$ = this.storeSelect(selectors.getShowInactiveClubs);
  defaultDiscountType$ = this.storeSelect(selectors.getDefaultDiscountType);
  defaultDiscountAmount$ = this.storeSelect(selectors.getDefaultDiscountAmount);
  defaultDiscountPercentage$ = this.storeSelect(selectors.getDefaultDiscountPercentage);
  newClubHeader$ = this.storeSelect(selectors.getNewClubHeader);
  editClubHeader$ = this.storeSelect(selectors.getEditClubHeader);
  deactivateClub$ = this.storeSelect(selectors.getDeactivateClub);
  syncClubMembers$ = this.storeSelect(selectors.getSyncClubMembers);
  syncClubMembersHelper$ = this.storeSelect(selectors.getSyncClubMembersHelper);
  createClubSuccess$ = this.storeSelect(selectors.getCreateClubSuccess);
  updateClubSuccess$ = this.storeSelect(selectors.getUpdateClubSuccess);
  deleteClubConfirm$ = this.storeSelect(selectors.getDeleteClubConfirm);

  // OBSERVABLE'S VALUES
  get clubName() {
    return this.storeSnapshot(this.clubName$);
  }

  get clubCode() {
    return this.storeSnapshot(this.clubCode$);
  }

  get clubStartDate() {
    return this.storeSnapshot(this.clubStartDate$);
  }

  get clubEndDate() {
    return this.storeSnapshot(this.clubEndDate$);
  }

  get name() {
    return this.storeSnapshot(this.name$);
  }

  get code() {
    return this.storeSnapshot(this.code$);
  }

  get startDate() {
    return this.storeSnapshot(this.startDate$);
  }

  get endDate() {
    return this.storeSnapshot(this.endDate$);
  }

  get defaultDiscountAmount() {
    return this.storeSnapshot(this.defaultDiscountAmount$);
  }

  get defaultDiscountPercentage() {
    return this.storeSnapshot(this.defaultDiscountPercentage$);
  }

  get createClubSuccess() {
    return this.storeSnapshot(this.createClubSuccess$);
  }

  get updateClubSuccess() {
    return this.storeSnapshot(this.updateClubSuccess$);
  }
}
